"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopyMatrix = exports.RiskTargetUtils = exports.getPercentileId = exports.getConsequenceId = exports.getFrequencyId = exports.ConsequencePercentiles = exports.getIndex = exports.getSorter = exports.displayHeader = exports.isConsequence = exports.isFrequency = exports.displayFrequency = exports.FrequencyDisplayChoices = exports.displayConsequence = exports.ConsequenceDisplayChoices = exports.getColorChoiceById = exports.MATRIX_MAX_SIZE = void 0;
exports.MATRIX_MAX_SIZE = 8;
function getColorChoiceById(choices, id) {
    return choices.find(function (choice) { return parseInt(choice.value) == id; });
}
exports.getColorChoiceById = getColorChoiceById;
var ConsequenceDisplayChoices = (function () {
    function ConsequenceDisplayChoices() {
    }
    ConsequenceDisplayChoices.asChoices = function (percentiles) {
        var options = [
            {
                display_name: gettext("Description"),
                value: ConsequenceDisplayChoices.DESCRIPTION.toString(),
            },
            {
                display_name: gettext("Absolute values"),
                value: ConsequenceDisplayChoices.ABSOLUTE.toString(),
            },
        ];
        if (percentiles) {
            options.push({
                display_name: gettext("Percentiles"),
                value: ConsequenceDisplayChoices.PERCENTILES.toString(),
            });
        }
        return options;
    };
    ConsequenceDisplayChoices.DESCRIPTION = 10;
    ConsequenceDisplayChoices.PERCENTILES = 20;
    ConsequenceDisplayChoices.ABSOLUTE = 30;
    return ConsequenceDisplayChoices;
}());
exports.ConsequenceDisplayChoices = ConsequenceDisplayChoices;
function displayConsequence(cons, display) {
    if (display == ConsequenceDisplayChoices.DESCRIPTION) {
        return cons.description;
    }
    else if (display == ConsequenceDisplayChoices.PERCENTILES) {
        return "".concat(cons.percentile_low.toFixed(4), " - ").concat(cons.percentile_high.toFixed(4));
    }
    else if (display == ConsequenceDisplayChoices.ABSOLUTE) {
        return "".concat(cons.low, " - ").concat(cons.high);
    }
}
exports.displayConsequence = displayConsequence;
var FrequencyDisplayChoices = (function () {
    function FrequencyDisplayChoices() {
    }
    FrequencyDisplayChoices.asChoices = function () {
        return [
            {
                display_name: gettext("Description"),
                value: FrequencyDisplayChoices.DESCRIPTION.toString(),
            },
            {
                display_name: gettext("Absolute values"),
                value: FrequencyDisplayChoices.ABSOLUTE.toString(),
            },
        ];
    };
    FrequencyDisplayChoices.DESCRIPTION = 10;
    FrequencyDisplayChoices.ABSOLUTE = 20;
    return FrequencyDisplayChoices;
}());
exports.FrequencyDisplayChoices = FrequencyDisplayChoices;
function displayFrequency(freq, display) {
    if (display == FrequencyDisplayChoices.DESCRIPTION) {
        return freq.description;
    }
    else if (display == FrequencyDisplayChoices.ABSOLUTE) {
        return "".concat(freq.low, " - ").concat(freq.high);
    }
}
exports.displayFrequency = displayFrequency;
function isFrequency(item) {
    return "row" in item;
}
exports.isFrequency = isFrequency;
function isConsequence(item) {
    return "column" in item;
}
exports.isConsequence = isConsequence;
function displayHeader(item, display_type) {
    if (isConsequence(item)) {
        var consequence = item;
        return displayConsequence(consequence, display_type);
    }
    else if (isFrequency(item)) {
        var frequency = item;
        return displayFrequency(frequency, display_type);
    }
}
exports.displayHeader = displayHeader;
function getSorter(item) {
    if (isFrequency(item)) {
        return function (a, b) { return a.row - b.row; };
    }
    else if (isConsequence(item)) {
        return function (a, b) { return a.column - b.column; };
    }
}
exports.getSorter = getSorter;
function getIndex(item) {
    if (isFrequency(item)) {
        var frequency = item;
        return frequency.row;
    }
    else if (isConsequence(item)) {
        var consequence = item;
        return consequence.column;
    }
}
exports.getIndex = getIndex;
var ConsequencePercentiles = (function () {
    function ConsequencePercentiles() {
    }
    ConsequencePercentiles.LOW = "P(10)";
    ConsequencePercentiles.MID = "P(50)";
    ConsequencePercentiles.HIGH = "P(90)";
    return ConsequencePercentiles;
}());
exports.ConsequencePercentiles = ConsequencePercentiles;
function getFrequencyId(freq, level) {
    return "freq_".concat(freq.id, "_").concat(level);
}
exports.getFrequencyId = getFrequencyId;
function getConsequenceId(cons, level) {
    return "cons_".concat(cons.id, "_").concat(level);
}
exports.getConsequenceId = getConsequenceId;
function getPercentileId(cons, level) {
    return "perc_".concat(cons.id, "_").concat(level);
}
exports.getPercentileId = getPercentileId;
var RiskTargetUtils = (function () {
    function RiskTargetUtils() {
    }
    RiskTargetUtils.getRiskMatrix = function (target) {
        return target.matrices.filter(function (m) { return m.is_opportunity == false; })[0];
    };
    RiskTargetUtils.getOpportunityMatrix = function (target) {
        return target.matrices.filter(function (m) { return m.is_opportunity; })[0];
    };
    return RiskTargetUtils;
}());
exports.RiskTargetUtils = RiskTargetUtils;
function deepCopyMatrix(matrix) {
    var newMatrix = __assign({}, matrix);
    newMatrix.column_headers = matrix.column_headers.map(function (freq) { return (__assign({}, freq)); });
    newMatrix.row_headers = matrix.row_headers.map(function (cons) { return (__assign({}, cons)); });
    newMatrix.cells = matrix.cells.map(function (cell) { return (__assign({}, cell)); });
    return newMatrix;
}
exports.deepCopyMatrix = deepCopyMatrix;
